// extracted by mini-css-extract-plugin
export default {"component":"page_component__mNieP","tabs":"page_tabs__qjHCc","tab":"page_tab__5rpl+","active":"page_active__Mn-q+"};